export default __webpack_public_path__ + "static/media/093-diagonal-arrow-8.6bb9796e.png";